<template>
    <div class="row">
        <div class="col-12">
            <p class="card-subtitle mb-3">
                Confirme los detalles de la reserva de su cita una vez antes de continuar.
                <br>
                Le enviaremos los detalles de la reserva por correo electrónico a {{ data.email }}
            </p>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <div class="flex gap-2">
                        <label class="form-label fw-semibold">Responsable: </label>
                        <p>{{ data.first_name && data.last_name ? data.first_name + ' ' + data.last_name : '' }}</p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-4 row align-items-center">
                        <div class="col-sm-3">
                            <img :src="categories" width="75px" height="75px">
                        </div>
                        <div class="col-sm-9">
                            <label class="form-label fw-semibold">Categoría: </label>
                            <div>
                                <p>{{ data.category ? data.category.name : '' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-4 row align-items-center">
                        <div class="col-sm-3">
                            <img :src="participants" width="75px" height="75px">
                        </div>
                        <div class="col-sm-9">
                            <label class="form-label fw-semibold">Participantes: </label>
                            <div>
                                <p>{{ data.participants ? data.participants : 0 }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-4 row align-items-center">
                        <div class="col-sm-3">
                            <img :src="schedule" width="75px" height="75px">
                        </div>
                        <div class="col-sm-9">
                            <label class="form-label fw-semibold">Día de la cita: </label>
                            <div>
                                <p>{{ data.date }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-4 row align-items-center">
                        <div class="col-sm-3">
                            <img :src="hours" width="75px" height="75px">
                        </div>
                        <div class="col-sm-9">
                            <label class="form-label fw-semibold">Hora de la cita: </label>
                            <div>
                                <p>{{ data.time }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import categories from '@/assets/images/categories.png'
import participants from '@/assets/images/participants.png'
import hours from '@/assets/images/hours.png'
import schedule from '@/assets/images/schedule.png'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      categories,
      participants,
      hours,
      schedule
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/steps/Done.vue